<!-- =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== -->

<template xmlns="http://www.w3.org/1999/html">
  <div id="page-user-view">
        <div class="items-center" style="margin-left: 35%;margin-right: 35%;">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
<!--    <div class="items-center" style="margin-left: 35%;margin-right: 35%;">-->
<!--      <span :active.sync="user_not_found"-->
<!--        >{{ $t("coachingExperience.ce1") }}-->
<!--      </span>-->
<!--    </div>-->
<!--      <span>-->
<!--        <span>Check </span-->
<!--        ><router-link-->
<!--          :to="{ name: 'page-user-list' }"-->
<!--          class="text-inherit underline"-->
<!--          >All Users</router-link-->
<!--        >-->
<!--      </span>-->

    </vs-alert>
        </div>
    <vs-prompt
      title="Meeting Schedule"
      accept-text="Request Meeting"
      :cancel-text="$t('Cancel')"
      @cancel="clearFields"
      @accept="sendInvite"
      @close="clearFields"
      :active.sync="activePrompt"
    >

        <form @submit.prevent>
          <div  class="flex justify-between my-2">
            <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl3") }}</label>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full flex flex-wrap">
                <vs-input
                  v-model.number="startH"
                  type="number"
                  color="warning"
                  :min="0"
                  :max="23"
                  @change="setDate()"
                  @keyup="setDate()"
                  placeholder="HH"
                  id="startHour"
                />
              </div>
              <div class="vx-col md:w-1/2 w-full flex flex-wrap">
                <vs-input
                  v-model.number="startM"
                  type="number"
                  color="warning"
                  :min="0"
                  :max="59"
                  @change="setDate()"
                  @keyup="setDate()"
                  placeholder="MM"
                  id="startMinute"
                />
              </div>
            </div>
          </div>
          <div  class="flex justify-between my-2">
            <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl4") }}</label>
            <select
              class="selectType w-full dropdown timezone-select"
              v-model="timezone"
              @change="setDate()"
            >
              <optgroup label="Most Used Timezone">
                <option value="Asia/Kolkata" class="mt-4">Asia/Calcutta</option>
                <option value="Europe/Lisbon">Europe/Lisbon</option>
                <option value="GMT" class="mb-4">GMT</option>
              </optgroup>
              <optgroup label="All Timezones">
                <option
                  :key="index"
                  v-for="(allTimeZoneData, index) in allTimeZone"
                  :value="allTimeZoneData.value"
                >
                  {{ allTimeZoneData.value }}
                </option>
              </optgroup>
            </select>
          </div>
          <div  class="flex justify-between my-2">
            <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl2") }}</label>
            <datePicker id="weekend-datetime-picker"
                        v-model="meetingDate"
                        name = "meetingDate"
                        class="text-primary bg-none w-full"
                        :value="meetingDate"
                        :format="DatePickerFormat"
                        :disabledDates="disabledDates"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"></datePicker>
          </div>
          <div class="relative">
            <vs-textarea
              v-model="msg"
              name="msg"
              class="my-4 resize-0"
              placeholder="Meeting Purpose"
            >
              <!-- :maxlength="255"
              @keyup="checkMessageLength()" -->
            </vs-textarea>
            <!-- <span class="absolute bottom-0 right-0 mr-2">{{msgLength}} / <strong>255</strong></span> -->
          </div>
        </form>

    </vs-prompt>
    <div id="user-data" v-if="user_data">
      <!--      {{user_data}}-->
      <vx-card  class="mb-base">
        <!-- Avatar -->
        <div class="parent">
          <img class="image1 w-full" :src="require('@/assets/images/header/' + profileBannerImage + '.png')">
          <img v-if="user_data.avatar" key="onlineImg" :src="user_data.avatar" alt="user-img"   class="rounded-full shadow-md cursor-pointer block image2" />
          <img v-else key="onlineImg" src="@/assets/images/profile/avatar.png" alt="user-img"   class="rounded-full shadow-md cursor-pointer block image2" />

          <h1 class="items-center mt-4 text-margin" >
            <b>{{user_data.firstName}} {{user_data.lastName}}</b>
          </h1>
          <p class="items-center mt-4 text-margin" >
            Company: <b>{{user_data.company[0].name}}</b>
          </p>
          <p class="items-center mr-12 mt-4" style="float:right;">
            <vs-button
                icon-pack="feather"
                class="mr-4"
                @click="meetingRequest(coachTraineeId)"
            >Send a note to mentor to connect for session</vs-button>
          </p>
          <br>
          <br>
          <br>
          <br>

        </div>
        <!--        <div class="vx-row">-->
        <!--          &lt;!&ndash; Avatar Col &ndash;&gt;-->
        <!--          <div class="vx-col" id="avatar-col">-->
        <!--            <div class="img-container mb-4">-->
        <!--              <img :src="user_data.avatar" class="rounded w-full" />-->
        <!--            </div>-->
        <!--          </div>-->

        <!--          &lt;!&ndash; Information - Col 1 &ndash;&gt;-->
        <!--          <div class="vx-col flex-1" id="account-info-col-1">-->
        <!--            <table>-->

        <!--              <tr>-->
        <!--                <td class="font-semibold">{{ $t("profile.p2") }}</td>-->
        <!--                <td>{{ user_data.firstName }} {{ user_data.lastName }}</td>-->
        <!--              </tr>-->
        <!--              <tr>-->
        <!--                <td class="font-semibold">{{ $t("profile.p3") }}</td>-->
        <!--                <td>{{ user_data.email }}</td>-->
        <!--              </tr>-->
        <!--              &lt;!&ndash;<tr>-->
        <!--                <td class="font-semibold">Email</td>-->
        <!--                <td>{{ user_data.email }}</td>-->
        <!--              </tr>&ndash;&gt;-->
        <!--            </table>-->
        <!--          </div>-->
        <!--          &lt;!&ndash; /Information - Col 1 &ndash;&gt;-->

        <!--          &lt;!&ndash; Information - Col 2 &ndash;&gt;-->
        <!--          <div class="vx-col flex-1" id="account-info-col-2">-->
        <!--            <table>-->
        <!--              <tr>-->
        <!--                <td class="font-semibold">{{ $t("profile.p4") }}</td>-->
        <!--                <td>{{ user_data.status }}</td>-->
        <!--              </tr>-->
        <!--              &lt;!&ndash;<tr>-->
        <!--                <td class="font-semibold">User Type</td>-->
        <!--                <td>{{ user_data.user_type }}</td>-->
        <!--              </tr>&ndash;&gt;-->
        <!--              <tr v-if="user_data.company">-->
        <!--                <td class="font-semibold">{{ $t("profile.p5") }}</td>-->
        <!--                <td>{{ user_data.company[0].name }}</td>-->
        <!--              </tr>-->
        <!--            </table>-->
        <!--          </div>-->
        <!--          &lt;!&ndash; /Information - Col 2 &ndash;&gt;-->
        <!--          <div class="vx-col w-full flex" id="account-manage-buttons">-->
        <!--            <div v-if="companyName==='GALA.GAMES'">-->
        <!--              <vs-button-->
        <!--                icon-pack="feather"-->
        <!--                class="mr-4 items-end"-->
        <!--                @click="launchEditor"-->

        <!--              >Launch Editor</vs-button>-->
        <!--              <vs-icon  @click="syncGbData" icon-pack="feather" icon="icon-refresh-ccw" title="Sync User Data"/>-->
        <!--            </div>-->
        <!--            <div v-else-if="companyName==='Datarmony'">-->
        <!--              <vs-button-->
        <!--                icon-pack="feather"-->
        <!--                class="mr-4"-->
        <!--                @click="launchEditor(companyName)"-->
        <!--              >Launch Editor</vs-button>-->
        <!--              <vs-icon  @click="syncGbData" icon-pack="feather" icon="icon-refresh-ccw" title="Sync User Data"/>-->
        <!--            </div>-->
        <!--            <div v-else>-->
        <!--              <vs-button-->
        <!--                  icon-pack="feather"-->
        <!--                  class="mr-4"-->
        <!--                  @click="launchEditor"-->
        <!--              >Launch Editor</vs-button>-->
        <!--              <vs-icon  @click="syncGbData" icon-pack="feather" icon="icon-refresh-ccw" title="Sync User Data"/>-->
        <!--            </div>-->

        <!--            &lt;!&ndash;<vs-button-->
        <!--              type="border"-->
        <!--              color="danger"-->
        <!--              icon-pack="feather"-->
        <!--              icon="icon-trash"-->
        <!--              @click="confirmDeactivateRecord"-->
        <!--              >Deactivate Account</vs-button-->
        <!--            >&ndash;&gt;-->
        <!--          </div>-->
        <!--        </div>-->
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('profile.p21')" class="mb-base">
            <table class="mt-2">
              <tr >
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="MailIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold">Email :</span>
                  </div>
                </td>
                <td class="col-md-6 "><span class="ml-12">{{user_data.email}}</span></td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="SmartphoneIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold ">Phone :</span>
                  </div>
                </td>
                <td class="col-md-6"><span class="ml-12">{{user_data.mobile}}</span></td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="UserIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold">Gender :</span>
                  </div>
                </td>
                <td class="col-md-6"><span class="ml-12">{{user_data.gender}}</span></td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="CalendarIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold">Date of Birth :</span>
                  </div>
                </td>
                <td class="col-md-6"><span class="ml-12">{{formatDate(user_data.dob)}}</span></td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold">Status :</span>
                  </div>
                </td>
                <td class="col-md-6 " v-if="user_data.status==='active'"><span class="ml-12"><vs-chip class="bg-success ml-12" style="color: white;"><ul><li>{{user_data.status}}</li></ul></vs-chip></span></td>
                <td class="col-md-6 " v-else-if="user_data.status==='blocked'"><span class="ml-12"><vs-chip class="bg-danger-gradient ml-12" style="color: white;"><ul><li>{{user_data.status}}</li></ul></vs-chip></span></td>
                <td class="col-md-6 " v-else><span class="ml-12"><vs-chip class="bg-warning ml-12" style="color: white;"><ul><li>{{user_data.status}}</li></ul></vs-chip></span></td>
              </tr>
            </table>
          </vx-card>
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('socialLink')" class="mb-base" style="height: 230px;">
            <table class="mt-3">
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center" v-if="user_data.facebook">
                    <feather-icon icon="FacebookIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.facebook}}</a></span>
                  </div>
                </td>

              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center" v-if="user_data.twitter">
                    <feather-icon icon="TwitterIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.twitter}}</a></span>
                  </div>
                </td>

              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center" v-if="user_data.linkedin">
                    <feather-icon icon="LinkedinIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.linkedin}}</a></span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center" v-if="user_data.linkedin">
                    <feather-icon icon="GithubIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.linkedin}}</a></span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="col-md-6 " >
                  <div class="flex items-center" v-if="user_data.linkedin">
                    <feather-icon icon="GlobeIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.linkedin}}</a></span>
                  </div>
                </td>
              </tr>

            </table>
          </vx-card>
        </div>
      </div>

      <!-- Permissions -->
      <!--<vx-card>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Permissions</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <div class="block overflow-x-auto">
          <table class="w-full permissions-table">
            <tr>
              &lt;!&ndash;
                You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
                our data structure. You just have to loop over above variable to get table headers.
                Below we made it simple. So, everyone can understand.
               &ndash;&gt;
              <th
                class="font-semibold text-base text-left px-3 py-2"
                v-for="heading in [
                  'Module',
                  'Read',
                  'Write',
                  'Create',
                  'Delete'
                ]"
                :key="heading"
              >
                {{ heading }}
              </th>
            </tr>

            <tr v-for="(val, name) in user_data.permissions" :key="name">
              <td class="px-3 py-2">{{ name }}</td>
              <td
                v-for="(permission, name) in val"
                class="px-3 py-2"
                :key="name + permission"
              >
                <vs-checkbox v-model="val[name]" class="pointer-events-none" />
              </td>
            </tr>
          </table>
        </div>
      </vx-card>-->
    </div>
<!--    <div id="user-data" v-if="user_data">-->
<!--      <vx-card :title="$t('Account')" class="mb-base">-->
<!--        &lt;!&ndash; Avatar &ndash;&gt;-->
<!--        <div class="vx-row">-->
<!--          &lt;!&ndash; Avatar Col &ndash;&gt;-->
<!--          <div class="vx-col" id="avatar-col">-->
<!--            <div class="img-container mb-4">-->
<!--              <img :src="user_data.avatar" class="rounded w-full" />-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; Information - Col 1 &ndash;&gt;-->
<!--          <div class="vx-col flex-1" id="account-info-col-1">-->
<!--            <table>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p1') }}</td>-->
<!--                <td>{{ user_data.username }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p2') }}</td>-->
<!--                <td>{{ user_data.firstName }} {{ user_data.lastName }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p3') }}</td>-->
<!--                <td>{{ user_data.email }}</td>-->
<!--              </tr>-->
<!--              &lt;!&ndash;<tr>-->
<!--                <td class="font-semibold">Email</td>-->
<!--                <td>{{ user_data.email }}</td>-->
<!--              </tr>&ndash;&gt;-->
<!--            </table>-->
<!--          </div>-->
<!--          &lt;!&ndash; /Information - Col 1 &ndash;&gt;-->

<!--          &lt;!&ndash; Information - Col 2 &ndash;&gt;-->
<!--          <div class="vx-col flex-1" id="account-info-col-2">-->
<!--            <table>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p4') }}</td>-->
<!--                <td>{{ user_data.status }}</td>-->
<!--              </tr>-->
<!--              &lt;!&ndash;<tr>-->
<!--                <td class="font-semibold">User Type</td>-->
<!--                <td>{{ user_data.user_type }}</td>-->
<!--              </tr>&ndash;&gt;-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p5') }}</td>-->
<!--                <td>{{ user_data.company[0].name }}</td>-->
<!--              </tr>-->
<!--            </table>-->
<!--          </div>-->
<!--          &lt;!&ndash; /Information - Col 2 &ndash;&gt;-->
<!--          <div class="vx-col w-full flex" id="account-manage-buttons">-->
<!--            &lt;!&ndash;<vs-button-->
<!--              icon-pack="feather"-->
<!--              icon="icon-edit"-->
<!--              class="mr-4"-->
<!--              :to="{-->
<!--                name: 'user-profile-edit'-->
<!--              }"-->
<!--              >Edit</vs-button-->
<!--            >&ndash;&gt;-->
<!--            &lt;!&ndash;<vs-button-->
<!--              type="border"-->
<!--              color="danger"-->
<!--              icon-pack="feather"-->
<!--              icon="icon-trash"-->
<!--              @click="confirmDeactivateRecord"-->
<!--              >Deactivate Account</vs-button-->
<!--            >&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </vx-card>-->

<!--      <div class="vx-row">-->
<!--        <div class="vx-col lg:w-1/2 w-full">-->
<!--          <vx-card :title="$t('Information')" class="mb-base">-->
<!--            <table>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p7') }}</td>-->
<!--                <td>{{ user_data.dob }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p8') }}</td>-->
<!--                <td>{{ user_data.mobile }}</td>-->
<!--              </tr>-->
<!--              &lt;!&ndash;<tr>-->
<!--                <td class="font-semibold">Website</td>-->
<!--                <td>{{ user_data.website }}</td>-->
<!--              </tr>&ndash;&gt;-->
<!--              &lt;!&ndash;<tr>-->
<!--                <td class="font-semibold">Languages</td>-->
<!--                <td>{{ user_data.languages_known.join(", ") }}</td>-->
<!--              </tr>&ndash;&gt;-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p9') }}</td>-->
<!--                <td>{{ user_data.gender }}</td>-->
<!--              </tr>-->
<!--              &lt;!&ndash;<tr>-->
<!--                <td class="font-semibold">Contact</td>-->
<!--                <td>{{ user_data.contact_options.join(", ") }}</td>-->
<!--              </tr>&ndash;&gt;-->
<!--            </table>-->
<!--          </vx-card>-->
<!--          <vs-button @click="meetingRequest(coachTraineeId)">Send a note to mentor to connect for session </vs-button>-->
<!--&lt;!&ndash;          <trainee-coach-notes v-bind:commuId="coachId" title="Send a note to mentor to connect for session" v-bind:key="'note-'+coachId"></trainee-coach-notes>&ndash;&gt;-->
<!--        </div>-->

<!--        <div class="vx-col lg:w-1/2 w-full">-->
<!--          <vx-card :title="$t('Address')" class="mb-base">-->
<!--            <table>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p10') }}</td>-->
<!--                <td>{{ user_data.addLine1 }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p11') }}</td>-->
<!--                <td>{{ user_data.addLine2 }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p12') }}</td>-->
<!--                <td>{{ user_data.city }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p13') }}</td>-->
<!--                <td>{{ user_data.state }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p14') }}</td>-->
<!--                <td>{{ user_data.country }}</td>-->
<!--              </tr>-->
<!--              &lt;!&ndash;<tr>-->
<!--                <td class="font-semibold">Slack</td>-->
<!--                <td>{{ user_data.social_links.slack }}</td>-->
<!--              </tr>&ndash;&gt;-->
<!--            </table>-->
<!--          </vx-card>-->
<!--        </div>-->

<!--        <div class="vx-col lg:w-1/2 w-full">-->
<!--          <vx-card :title="$t('socialLink')" class="mb-base">-->
<!--            <table>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p15') }}</td>-->
<!--                <td>{{ user_data.twitter }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p16') }}</td>-->
<!--                <td>{{ user_data.facebook }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p17') }}</td>-->
<!--                <td>{{ user_data.instagram }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t('profile.p18') }}</td>-->
<!--                <td>{{ user_data.linkedin }}</td>-->
<!--              </tr>-->
<!--            </table>-->
<!--          </vx-card>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Permissions &ndash;&gt;-->
<!--      &lt;!&ndash;<vx-card>-->
<!--        <div class="vx-row">-->
<!--          <div class="vx-col w-full">-->
<!--            <div class="flex items-end px-3">-->
<!--              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />-->
<!--              <span class="font-medium text-lg leading-none">Permissions</span>-->
<!--            </div>-->
<!--            <vs-divider />-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="block overflow-x-auto">-->
<!--          <table class="w-full permissions-table">-->
<!--            <tr>-->
<!--              &lt;!&ndash;-->
<!--                You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,-->
<!--                our data structure. You just have to loop over above variable to get table headers.-->
<!--                Below we made it simple. So, everyone can understand.-->
<!--               &ndash;&gt;-->
<!--              <th-->
<!--                class="font-semibold text-base text-left px-3 py-2"-->
<!--                v-for="heading in [-->
<!--                  'Module',-->
<!--                  'Read',-->
<!--                  'Write',-->
<!--                  'Create',-->
<!--                  'Delete'-->
<!--                ]"-->
<!--                :key="heading"-->
<!--              >-->
<!--                {{ heading }}-->
<!--              </th>-->
<!--            </tr>-->

<!--            <tr v-for="(val, name) in user_data.permissions" :key="name">-->
<!--              <td class="px-3 py-2">{{ name }}</td>-->
<!--              <td-->
<!--                v-for="(permission, name) in val"-->
<!--                class="px-3 py-2"-->
<!--                :key="name + permission"-->
<!--              >-->
<!--                <vs-checkbox v-model="val[name]" class="pointer-events-none" />-->
<!--              </td>-->
<!--            </tr>-->
<!--          </table>-->
<!--        </div>-->
<!--      </vx-card>&ndash;&gt;-->
<!--    </div>-->
  </div>
</template>

<script>
// import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import Notes from '@/layouts/components/navbar/components/Notes.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import datePicker from "vuejs-datepicker"
import { models } from "feathers-vuex"
import allTimeZone from './allTimeZone';
import Moment from 'vue-moment';
import moment from "moment";
import i18n from "@/i18n/i18n";
export default {
  data() {
    return {
      meetingDate: new Date(),
      DatePickerFormat: 'dd/MM/yyyy',
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      startH:
        moment().minutes() + 5 > 59
          ? (moment().hours() + 1) % 24
          : moment().hours() % 24,
      startM: (moment().minutes() + 5) % 60,
      schedule_time:'',
      timezone:'',
      userRole : this.$store.state.AppActiveUser.userType,
      msg : null,
      msgLength : 0,
      communicationId:'',
      userId: this.$store.state.AppActiveUser.usersId,
      allTimeZone,
      user_data: null,
      user_not_found: false,
      userType: this.$store.state.AppActiveUser.userType,
      coachTraineeId:'',
      activePrompt:false,
      query:null,
      notes:[],
      profileBannerImage:'',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3
      }
    };
  },
  components: {
    Notes,
    datePicker,
    moment,
    VuePerfectScrollbar
  },
  computed: {
    userAddress() {
      let str = "";
      for (const field in this.user_data.location) {
        str += `${field} `;
      }
      return str;
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: i18n.t('notification.user.myCoach.deleteUser.confirm.c1'),
        text:  i18n.t('notification.user.myCoach.deleteUser.confirm.c2',{ username: this.user_data.username}),
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    formatDate(sentDate) {
      let date = new Date(sentDate)
      console.log("sent date", date);
      date = `${date.getFullYear()  }-${  date.getMonth() + 1  }-${  date.getDate()}`;
      return date;
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      // this.$router.push({ name: "admin-user-list" });
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store
        .dispatch("userManagement/removeRecord", this.user_data.id)
        .then(() => {
          this.$router.push({ name: "admin-user-list" });
          this.showDeleteSuccess();
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: i18n.t('notification.user.myCoach.deleteUser.success.d1'),
        text:  i18n.t('notification.user.myCoach.deleteUser.success.d2'),
      });
    },
    meetingRequest(){
       this.activePrompt=true;
    },
    clearFields () {
      this.$nextTick(() => {
        this.user_email = "";
      });
    },
    sendInvite () {
      if(this.meetingDate){
        this.meetingDate = this.meetingDate
        this.startD = moment.utc(this.meetingDate).format('YYYY-MM-DD');
        this.schedule_time =
          this.startD + ' ' + this.startH + ':' + this.startM + ':00';
      }else{
        this.schedule_time=null;
      }

      const note = new models.api.Usercoach_Notes({
        userRole: this.userRole,
        noteType: 4,
        authorId: this.userId,
        commuId:this.coachTraineeId,
        company:window.$cookies.get('companyName'),
        loginType:this.$store.state.AppActiveUser.userType,
        message: this.msg,
        timezone:this.timezone,
        status: 0,
        meetingDate: this.schedule_time
      });
      if(this.msg){
        this.$store.dispatch("notesManagement/addNote", note).
        then(res => {
          console.log('payload note',res);
          this.$vs.notify({
            title: i18n.t('notification.user.myCoach.addNote.success.a1'),
            text:  i18n.t('notification.user.myCoach.addNote.success.a2'),
            color: "primary"
          });
          this.fetchNotes();
        })
            .catch(err => {
              console.log("note create failed", err);
              this.$vs.notify({
                title: i18n.t('notification.user.myCoach.addNote.failed.a1'),
                text:  i18n.t('notification.user.myCoach.addNote.failed.a2'),
                color: "danger"
              });
            });
        this.msg = null;
      }
      else{
        this.$vs.notify({
          title: 'Warning',
          text:  'Meeting Purpose field is Required',
          color: "warning"
        });
      }
    },
    fetchNotes: function(){
      this.$store.dispatch("notesManagement/fetchNotes",{query:this.query}).then(res => {
        this.notes = [];
        for(let i=0;i<res.data.length;i++){
          this.$store.dispatch("userManagement/fetchUser", res.data[i].authorId)
            .then(userDetail => {
              let firstName = userDetail.firstName;
              let lastName = userDetail.latName;
              let avatar = userDetail.avatar;
              res.data[i] = {...res.data[i],firstName,lastName,avatar};
              this.notes.push(res.data[i]);

              console.log('notes data' ,this.notes);
            })
            .catch(err => {
              console.error("cant fetch user",err);
            });
        }
      })
        .catch(err => {
          console.error(err);
        });
    },
  },
  created() {
    // Register Module UserManagement Module
    /*if (!moduleUserManagement.isRegistered) {
        this.$store.registerModule("userManagement", moduleUserManagement);
        moduleUserManagement.isRegistered = true;
      }*/
    if(localStorage.getItem("themeColor")==='#9DCD5B'){
      this.profileBannerImage='header_img1'
    }
    else if(localStorage.getItem("themeColor")==='#6859B4'){
      this.profileBannerImage='header_img2'
    }
    else if(localStorage.getItem("themeColor")==='#3BA0BE'){
      this.profileBannerImage='header_img3'
    }else if(localStorage.getItem("themeColor")==='#E4D033'){
      this.profileBannerImage='header_img4'
    }else if(localStorage.getItem("themeColor")==='#EA7526'){
      this.profileBannerImage='header_img5'
    }else if(localStorage.getItem("themeColor")==='#C6211B'){
      this.profileBannerImage='header_img6'
    }else if(localStorage.getItem("themeColor")==='#F36677'){
      this.profileBannerImage='header_img7'
    }else if(localStorage.getItem("themeColor")==='#B3B3B3'){
      this.profileBannerImage='header_img8'
    }
    else if(localStorage.getItem("themeColor")==='#000066'){
      this.profileBannerImage='header_img9'
    }
    else {
      this.profileBannerImage='header_img1'
    }
    let query=''
    if(this.userRole === 'coach'){
      query = {$and:[{coachId:this.userId},{traineeId:this.commuId}]}
    }
    else if(this.userRole === 'trainee'){
      query = {traineeId:this.$store.state.AppActiveUser.usersId}
    }
    this.$store
      .dispatch("traineeCoachAssignment/fetchAssignTraineeCoachQuery", {
        query: query
      })
      .then(res => {
        let receiverId;
        if(res.data.length===1){
          if(this.userRole === 'trainee'){
            receiverId = res.data[0].coachId;
            this.communicationId = receiverId;
          }
          if(this.userRole === 'coach'){
            receiverId = res.data[0].traineeId;
            this.communicationId = receiverId;
          }
        }
        else if(res.data.length===0){
          receiverId = this.commuId;
          this.communicationId = this.commuId;
        }
        else{
          console.log("something is wrong we have found more than 1 data")
        }
        this.query = {$and:[{authorId:{$in:[this.userId,receiverId]}},{commuId:{$in:[this.userId,receiverId]}},{status:0}], $sort: { createdAt: -1 } }
        this.fetchNotes();
      })
      .catch(err => {
        console.log("trainee coach not found", err);
      });

    const usersId = this.$store.state.AppActiveUser.usersId;
    console.log(usersId);
    // const userType = this.$store.state.AppActiveUser.userType;
    this.$store
      .dispatch("traineeCoachAssignment/fetchAssignTraineeCoachQuery", {
        query: { traineeId: usersId }
      })
      .then(res => {
        console.log('Coach Details',res);
         this.coachTraineeId=res.data[0].coachId;
        if(res.data.length===1){
          this.$store
            .dispatch("userManagement/fetchUser", res.data[0].coachId)
            .then(resCoach => {
              this.user_data = resCoach;

              console.log("user data view", this.user_data);
            })
            .catch(err => {
               this.user_not_found = true;
              // if (errCoach.response.status === 404) {
              //   return;
              // }
              // console.error(errCoach);
            });
        }
        else{
          this.user_not_found = true;
        }

      })
      .catch(err => {
        console.log("trainee coach not found", err);
      });
  }
};
</script>

<style lang="scss">
.vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0rem;
}
.parent {
  position: relative;
  top: 0;
  left: 0;
}
.image1 {
  position: relative;
  top: 0;
  left: 0;

}
.image2 {
  position: absolute;
  top: 80px;
  left: 50px;
  height: 180px;
  width: 180px;
}
.image3 {
  position: absolute;
  top: 220px;
  left: 180px;
  height:35px;
  width:35px;
  background: #D0D5DD;
  border: 2px solid #FFFFFF;
  border-radius: 100px;
}
.text-margin{
  margin-left: 20%;
}
#avatar-col {
  width: 10rem;
}
.editor-iframe {
  width: 100%;
  height: calc(100vh);
}
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}
@media (max-width: 480px) {
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 20px;
    left: 20px;
    height: 70px;
    width:70px;


  }
  .image3 {
    position: absolute;
    top: 60px;
    left: 70px;
    height:25px;
    width:25px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 35%;
    font-size: 12px;
  }
  .refresh-img{
    height: 15px;
  }
}

/* Media Query for low resolution  Tablets, Ipads */
@media (min-width: 481px) and (max-width: 767px) {
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 40px;
    left: 50px;
    height: 100px;
    width: 100px;


  }
  .image3 {
    position: absolute;
    top: 110px;
    left: 120px;
    height:30px;
    width:30px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 30%;
  }
  .refresh-img{
    height: 20px;
  }
}

/* Media Query for Tablets Ipads portrait mode */
@media (min-width: 768px) and (max-width: 1024px){
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 40px;
    left: 50px;
    height: 100px;
    width: 100px;


  }
  .image3 {
    position: absolute;
    top: 110px;
    left: 120px;
    height:30px;
    width:30px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 30%;
  }
  .refresh-img{
    height: 20px;
  }
}

/* Media Query for Laptops and Desktops */
@media (min-width: 1025px) and (max-width: 1280px){
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .refresh-img{
    height: 15px;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 60px;
    left: 30px;
    height: 150px;
    width: 150px;
  }
  .image3 {
    position: absolute;
    top: 180px;
    left: 135px;
    height:25px;
    width:25px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 20%;

  }
}

/* Media Query for Large screens */
@media (min-width: 1281px) {
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .refresh-img{
    height: 15px;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 60px;
    left: 30px;
    height: 150px;
    width: 150px;
  }
  .image3 {
    position: absolute;
    top: 180px;
    left: 135px;
    height:25px;
    width:25px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 20%;
  }
}





// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


</style>
